module.exports = __webpack_public_path__ + "img/tu3@2x.f93e73e2.png";